import { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./LegalFooter.module.scss";
import TermsConditionsModal from "./TermsConditionsModal";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import RefundPolicyModal from "./RefundPolicyModal";

const LegalFooter = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);

  return (
    <>
      <footer className={styles.legalFooter}>
        <div className={styles.container}>
          <div className={styles.topRow}>
            <div className={styles.brand}>
              <div className={styles.logo}>
                <span className={styles.munafa}>MUNAFA</span>{" "}
                <span className={styles.engine}>ENGINE</span>
              </div>
              <p className={styles.tagline}>Weekly Munafa Clarity for Salon Owners</p>
            </div>
            <div className={styles.links}>
              <Link to="/" className={styles.link}>Home</Link>
              <span className={styles.separator}>|</span>
              <button onClick={() => setIsTermsModalOpen(true)} className={styles.linkBtn}>
                Terms & Conditions
              </button>
              <span className={styles.separator}>|</span>
              <button onClick={() => setPrivacyModalOpen(true)} className={styles.linkBtn}>
                Privacy Policy
              </button>
              <span className={styles.separator}>|</span>
              <button onClick={() => setIsRefundModalOpen(true)} className={styles.linkBtn}>
                Refund & Cancellation Policy
              </button>
            </div>
          </div>
          <div className={styles.bottomRow}>
            <p className={styles.copyright}>Copyright © 2026 Munafa Engine. All rights reserved..</p>
          </div>
        </div>
      </footer>
      <TermsConditionsModal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
        onOpenPrivacy={() => {
          setIsTermsModalOpen(false);
          setPrivacyModalOpen(true);
        }}
        onOpenRefund={() => {
          setIsTermsModalOpen(false);
          setIsRefundModalOpen(true);
        }}
      />
      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setPrivacyModalOpen(false)}
        onOpenTerms={() => {
          setPrivacyModalOpen(false);
          setIsTermsModalOpen(true);
        }}
        onOpenRefund={() => {
          setPrivacyModalOpen(false);
          setIsRefundModalOpen(true);
        }}
      />
      <RefundPolicyModal
        isOpen={isRefundModalOpen}
        onClose={() => setIsRefundModalOpen(false)}
        onOpenTerms={() => {
          setIsRefundModalOpen(false);
          setIsTermsModalOpen(true);
        }}
        onOpenPrivacy={() => {
          setIsRefundModalOpen(false);
          setPrivacyModalOpen(true);
        }}
      />
    </>
  );
};

export default LegalFooter;
